import getPatientAddress from 'utils/print/getPatientAddress';

const getInsuranceInsuredsAddress = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  return getPatientAddress(otherProps);
};

export default getInsuranceInsuredsAddress;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsAddress.js